import { mapState } from 'vuex'

const webAppsPanelId = '174'
const webAppsModuleId = '74'
const bizviewPanelId = '86'
const bizviewModuleId = '186'
const userPanelId = '171'
const userModuleId = '73'
export const modulesIconMixin = {
  computed: {
    ...mapState('search', [
      'index'
    ]),
    webAppsItem () {
      return this.index && this.index[webAppsPanelId]
    },
    webAppsModuleItem () {
      return this.index && this.index[webAppsModuleId]
    },
    bizViewItem () {
      return this.index && this.index[bizviewPanelId]
    },
    bizViewModuleItem () {
      return this.index && this.index[bizviewModuleId]
    },
    userItem () {
      return this.index && this.index[userPanelId]
    },
    userModuleItem () {
      return this.index && this.index[userModuleId]
    }
  }
}
